import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  LANGUAGES,
  LANGUAGE_CODES,
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  normalizeLanguage,
} from './languages';

// locales/<dil>/<namespace>.json dosyalarının hepsi otomatik yüklenir.
// Yeni dil ya da namespace eklemek için dosyayı koymak yeterli.
const localeContext = require.context('./locales', true, /^\.\/[a-z]{2}\/[A-Za-z0-9_-]+\.json$/);
const resources = {};
const namespaceSet = new Set();
localeContext.keys().forEach((key) => {
  const [, lang, ns] = key.match(/^\.\/([a-z]{2})\/([A-Za-z0-9_-]+)\.json$/);
  if (!LANGUAGE_CODES.includes(lang)) return;
  resources[lang] = resources[lang] || {};
  resources[lang][ns] = localeContext(key);
  namespaceSet.add(ns);
});

export const LANGUAGE_STORAGE_KEY = 'gameLanguage';

export const SUPPORTED_LANGUAGES = LANGUAGES;

export function getStoredLanguage() {
  let stored = null;
  try { stored = localStorage.getItem(LANGUAGE_STORAGE_KEY); } catch { /* yoksay */ }
  return normalizeLanguage(stored || DEFAULT_LANGUAGE);
}

export function setGameLanguage(code) {
  const lang = normalizeLanguage(code);
  try { localStorage.setItem(LANGUAGE_STORAGE_KEY, lang); } catch { /* yoksay */ }
  document.documentElement.lang = lang;
  return i18n.changeLanguage(lang);
}

const initialLanguage = getStoredLanguage();
document.documentElement.lang = initialLanguage;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  supportedLngs: LANGUAGE_CODES,
  // Türkçe kendi içinde kalır; diğer diller eksik anahtarda önce İngilizceye, sonra Türkçeye düşer.
  fallbackLng: {
    [DEFAULT_LANGUAGE]: [DEFAULT_LANGUAGE],
    default: [FALLBACK_LANGUAGE, DEFAULT_LANGUAGE],
  },
  defaultNS: 'common',
  ns: Array.from(namespaceSet),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
